import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { ExistingQuestion } from 'components/configure-modals/configure-from-existing-questions/types';
import { FILTER_VALUES } from 'components/configure-modals/configure-from-existing-questions/existing-questions/existing-questions.constants';

interface UseSearchAndSortReturn {
  results: ExistingQuestion[];
  search: string;
  setSearch: Dispatch<SetStateAction<string>>;
  filter: FILTER_VALUES | null;
  setFilter: Dispatch<SetStateAction<FILTER_VALUES>>;
}

export const useSearchAndFilter = (
  existingQuestions: ExistingQuestion[]
): UseSearchAndSortReturn => {
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState<FILTER_VALUES>(null);
  const [results, setResults] = useState<ExistingQuestion[]>(existingQuestions);

  useEffect(() => {
    let processedExistingQuestions: ExistingQuestion[] = existingQuestions;

    if (filter) {
      processedExistingQuestions = processedExistingQuestions.filter(
        (item) => item.questionTemplateId === filter
      );
    }

    if (search) {
      processedExistingQuestions = processedExistingQuestions.filter((item) =>
        item.questionName.toLowerCase().includes(search.toLowerCase())
      );
    }

    setResults(processedExistingQuestions);
  }, [search, filter]);

  return {
    results,
    search,
    filter,
    setFilter,
    setSearch,
  };
};
